export default "__VITE_ASSET__COKX4$hF__"